




























































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Product, Company, Thematic, Show } from '../../store/modules/lib'
import { namespace } from 'vuex-class'

const event = namespace('event')
const auth = namespace('auth')

@Component
export default class ProductDlgMain extends Vue {
  @Prop({ type: Object, default: {} }) protected value!: Product
  @Prop({ type: Array, default: [] }) protected errorFields!: string[]
  @Prop({ type: Array, default: [] }) protected standCompanies!: Company[]

  @auth.State('showId') protected showId: any
  @event.Getter('shows') protected shows: any

  protected get thematicList (): string[] {
    let show = this.shows.filter((sh: Show) => sh._id == this.showId)[0]

    return show && show.thematics
      ? show.thematics
          .sort()
      : []
  }

  protected get standTitle (): string {
    let companies = this.standCompanies.filter((company: Company) => company._id == this.value._company && company.standTitle.trim() != '')

    return companies.length > 0 ? companies[0].standTitle : ''
  }

  protected fileSetting: any = {
    file: '',
    imagePreview: '',
    showPreview: false
  }

  compress(e : any) {
    return new Promise((resolve : any) => {
      const width = 300
      const height = 400
      const fileName = e.name
      const fileType = e.type
      const reader = new FileReader()

      reader.readAsDataURL(e)
      reader.onload = () => {
        const img = new Image()

        img.src = `${reader.result}`
        img.onload = () => {
          const elem = document.createElement('canvas');
          elem.width = width;
          elem.height = height
          const ctx = elem.getContext('2d')
          // img.width и img.height будет содержать оригинальные размеры
          if(ctx) {
            ctx.drawImage(img, 0, 0, width, height)
            ctx.canvas.toBlob((blob : any) => {
              const file = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
              });
              this.fileSetting.file = file
              this.fileSetting.isNew = true
              // this.fileSetting.imagePreview = file
            }, 'image/jpeg', 1)

            const data = ctx.canvas.toDataURL(fileType, 1)
            this.fileSetting.imagePreview = data

            resolve()
          }
        }
        reader.onerror = error => console.log(error)
      }
    })

  }

  changed(field: string, event: any) {
    event = event.trim()
    let value: any = this.value

    if (field === 'title') {
      value.title = event
    } else if (field === 'photo') {
      if(event === null) {
        this.fileSetting = {
          file: '',
          imagePreview: '',
          showPreview: false
        }
      } else {
        this.compress(event)
          .then(() => {
            this.fileSetting.showPreview = true
          })
      }

      this.$emit('addPhoto', this.fileSetting)
    } else if (field === 'vendorCode') {
      value.vendorCode = event
    } else if (field === 'thematic') {
      value.thematic = event
    } else if (field === 'stand') {
      let companies = this.standCompanies.filter((company: Company) => company.standTitle == event)

      if (companies.length > 0)
        value._company = companies[0]._id
    } else if (field === 'description') {
      value.description = event
    }

    this.$emit('input', value)
  }
}
